module.exports = __webpack_public_path__ + "img/map-of-japan.72a3deb2.png";